import { render } from "./BlockBarMenu.vue?vue&type=template&id=8c287a80&scoped=true&ts=true"
import script from "./BlockBarMenu.vue?vue&type=script&lang=ts"
export * from "./BlockBarMenu.vue?vue&type=script&lang=ts"

import "./BlockBarMenu.vue?vue&type=style&index=0&id=8c287a80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c287a80"]])

export default __exports__